import { useQuery } from '@tanstack/react-query';
import { fetchAnalysisItems } from '@services/analysisItems';

export function useAnalysisItems(studyId) {
  return useQuery({
    queryKey: ['analysisItems', studyId],
    queryFn: () => fetchAnalysisItems(studyId),

    enabled: !!studyId,
  });
}
